import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { AuthService } from '../auth.service';
import { UtilsService } from 'src/app/utils/utils.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  @Output() closeClick = new EventEmitter<boolean>();
  @Output() loggedIn = new EventEmitter<boolean>();
  authing = false;
  invalidCreds = false;
  constructor(private toastr: ToastrService,private utils:UtilsService, private route: ActivatedRoute, private authService: AuthService, private router: Router, private formsBuilder: FormBuilder) { }

  showLoginBox = true;

  loginForm: FormGroup;
  toUrl: string;
  ngOnInit() {

    this.utils.getShowLoginBox().subscribe(status => {
      this.showLoginBox = status;
    })

    this.toUrl = this.route.snapshot.queryParams.returnUrl;
    this.loginForm = this.formsBuilder.group({
      username: ['', Validators.required],
      password: ['', Validators.required]
    });
  }

  getFormControls() { return this.loginForm.controls; }

  async login() {
    this.invalidCreds = false;
    this.authing = true;
    if(this.loginForm.invalid) {
      return;
    }

    await this.authService.login(this.loginForm.value).subscribe(response => {
      if(response.result.success){
        localStorage.setItem('ACCESS_TOKEN', response.result.content.token.toString());
        localStorage.setItem('USER_INFO',JSON.stringify(response.result.content.userDetails))
        localStorage.setItem('LOGIN_RESPONSE',JSON.stringify(response))
        this.toastr.success('Login Successfull', '', {closeButton: true});
        this.utils.setLoginPrompt(true);
        this.loggedIn.emit(true)
        this.authing=false;
        this.utils.setShowLoginBox(false);
      }else{
        this.utils.setLoginPrompt(false);
        this.loggedIn.emit(false)
        this.invalidCreds = true;
        this.authing=false;
      }
    });
  }

  routeToForgot() {
    this.router.navigate(['/forgot-password']);
  }


  close() {
    this.invalidCreds = false;
    this.utils.setShowLoginBox(false);
    this.loginForm.reset();
     }  

  keyPressAlphaNumericWithCharacters(event) {

      var inp = String.fromCharCode(event.keyCode);
  
      if (/[a-zA-Z0-9._@]/.test(inp)) {
        return true;
      } else {
        event.preventDefault();
        return false;
      }
    }
}
